module.exports = __webpack_public_path__ + "static/media/icon-kompetenzen.372a2fee.svg";